import {
  AcademicSystem,
  australiaCountries,
  canadaCountries,
  europeCountries,
  indiaCountries,
  matchAcademicSystemByCountry,
  ukCountries,
  usCountries,
} from './academicCountryGroups';

export const ukExamOptions = [
  'GCSE',
  'AS Level',
  'A Level',
  'International Baccalaureate (IB)',
  'T Levels',
  'BTEC',
  'NVQ',
  'Scottish National 5',
  'Scottish Higher',
  'Scottish Advanced Higher',
  'Cambridge Pre-U',
  'Core Maths',
  'Functional Skills',
  'EPQ (Extended Project Qualification)',
  'SAT (UK usage for US university entry)',
  'ACT (UK usage for US university entry)',
  'IELTS',
  'TOEFL',
  'Cambridge English Exams (FCE, CAE, CPE)',
  '11+',
  '13+ Common Entrance Exam',
  'UKCAT (now UCAT)',
  'BMAT',
  'LNAT',
  'STEP',
  'MAT',
  'HAT',
  'PAT',
];

export const indiaExamOptions = [
  'Class 10 Board Exams',
  'Class 12 Board Exams',
  'Engineering Entrance',
  'Medical Entrance',
  'Civil Services & Govt',
  'Common Entrance',
  'Olympiads',
  'IELTS',
  'TOEFL',
];

export const usExamOptions = [
  'SAT',
  'ACT',
  'AP Exams',
  'PSAT / NMSQT',
  'GED',
  'SSAT',
  'ISEE',
  'TOEFL',
  'IELTS',
];

export const canadaExamOptions = [
  'EQAO',
  'Provincial Achievement Tests',
  'Diploma Exams',
  'OSSLT',
  'AP Exams',
  'International Baccalaureate (IB)',
  'IELTS',
  'TOEFL',
];

export const australiaExamOptions = [
  'NAPLAN',
  'HSC',
  'VCE',
  'QCE',
  'WACE',
  'SACE',
  'TASC',
  'NCEA',
  'UCAT ANZ',
  'IELTS',
];

export const europeExamOptions = [
  'International Baccalaureate (IB)',
  'IGCSE',
  'A Level',
  'European Baccalaureate',
  'Abitur',
  'Baccalaureat',
  'Matura / Maturita',
  'Bachillerato',
  'Esame di Stato',
  'IELTS',
  'Cambridge English Exams (FCE, CAE, CPE)',
];

export const examOptions = ukExamOptions;

const examSystems: AcademicSystem<string>[] = [
  {
    countries: indiaCountries,
    label: 'Indian exam structure',
    options: indiaExamOptions,
  },
  {
    countries: usCountries,
    label: 'US exam structure',
    options: usExamOptions,
  },
  {
    countries: canadaCountries,
    label: 'Canadian exam structure',
    options: canadaExamOptions,
  },
  {
    countries: australiaCountries,
    label: 'Australia and New Zealand exam structure',
    options: australiaExamOptions,
  },
  {
    countries: europeCountries,
    label: 'European exam structure',
    options: europeExamOptions,
  },
  {
    countries: ukCountries,
    label: 'UK exam structure',
    options: ukExamOptions,
  },
];

const defaultExamSystem: AcademicSystem<string> = {
  countries: [],
  label: 'Default exam structure',
  options: ukExamOptions,
};

export const getExamSystemByCountry = (country?: string) =>
  matchAcademicSystemByCountry(country, examSystems, defaultExamSystem);

export const getExamOptionsByCountry = (country?: string) =>
  getExamSystemByCountry(country).options;

export const getExamSystemLabelByCountry = (country?: string) =>
  getExamSystemByCountry(country).label;
